let utils = require('../../actions/utils');

module.exports = {
    closePopups: [
        utils.set('popups.active', [])
    ]
};



// WEBPACK FOOTER //
// ./signals/layout/index.js